var map = {
	"./AboutUS/About page optimized/About-us.webp": 9096,
	"./AboutUS/About page optimized/Amanpreet-kaur.webp": 8810,
	"./AboutUS/About page optimized/about-us-page-header.webp": 5602,
	"./AboutUS/About page optimized/about.webp": 3254,
	"./AboutUS/About page optimized/agile-scd.webp": 552,
	"./AboutUS/About page optimized/client-collaboration.webp": 2771,
	"./AboutUS/About page optimized/mahinga-singh.webp": 7972,
	"./AboutUS/About page optimized/mayank.webp": 7943,
	"./AboutUS/About page optimized/methodology.webp": 9526,
	"./AboutUS/About page optimized/scrum-certified-developers.webp": 9808,
	"./AboutUS/About page optimized/shubham.webp": 3185,
	"./AboutUS/About-image-1.jpg": 7522,
	"./AboutUS/About-us.webp": 9191,
	"./AboutUS/Amanpreet-kaur.png": 1992,
	"./AboutUS/Amanpreet-kaur.webp": 6232,
	"./AboutUS/Mahinga-Singh.png": 4139,
	"./AboutUS/Mayank.png": 4951,
	"./AboutUS/Shubham-Yadav.png": 3275,
	"./AboutUS/Team-Img.png": 7875,
	"./AboutUS/TechnologyIcons/Banking.png": 245,
	"./AboutUS/TechnologyIcons/automotive.png": 5870,
	"./AboutUS/TechnologyIcons/hi-tech.png": 9088,
	"./AboutUS/TechnologyIcons/industrial.png": 8934,
	"./AboutUS/TechnologyIcons/media.png": 3209,
	"./AboutUS/TechnologyIcons/medical.png": 2309,
	"./AboutUS/TechnologyIcons/side-arrow.png": 3350,
	"./AboutUS/about-us-page-header.png": 862,
	"./AboutUS/about-us-page-header.webp": 6036,
	"./AboutUS/about-us-red-2.webp": 9791,
	"./AboutUS/about-us-red.webp": 7583,
	"./AboutUS/about.webp": 6954,
	"./AboutUS/agile-scd.jpg": 5510,
	"./AboutUS/agile-scd.webp": 6289,
	"./AboutUS/client-collaboration.jpg": 346,
	"./AboutUS/client-collaboration.webp": 6229,
	"./AboutUS/industry-img.jpg": 5558,
	"./AboutUS/l1-half-circle-shape.688763e0d9bb6048a4b8b7ff8056089d.png": 7362,
	"./AboutUS/mahinga-singh.webp": 251,
	"./AboutUS/mayank.webp": 7577,
	"./AboutUS/methodology.jpg": 4979,
	"./AboutUS/methodology.webp": 3240,
	"./AboutUS/scrum-certified-developers.jpg": 9179,
	"./AboutUS/scrum-certified-developers.webp": 6010,
	"./AboutUS/shubham.webp": 2279,
	"./ContactImg/contactus-headerbg.webp": 6347,
	"./ContactImg/contactus-leftbg-res.png": 6646,
	"./HomeImg/About-us-03-02-red.jpg": 536,
	"./HomeImg/Alessandro-testimonial.webp": 5676,
	"./HomeImg/Alex-Orus-testimonial.jpg": 7336,
	"./HomeImg/Algoson-Software-and-SALU-offivce-V1.png": 9067,
	"./HomeImg/Algoson-Software-and-SALU-offivce-V1.webp": 4544,
	"./HomeImg/Client Logo/Alessandro.png": 6924,
	"./HomeImg/Client Logo/Favo-Investment.png": 9120,
	"./HomeImg/Client Logo/Gill-Brother.png": 6222,
	"./HomeImg/Client Logo/Grave-Angels.png": 3927,
	"./HomeImg/Client Logo/MAxxSoft.png": 8174,
	"./HomeImg/Client Logo/Ottawa.png": 8766,
	"./HomeImg/Client Logo/Stuward.png": 4095,
	"./HomeImg/Client Logo/TechMaxx-IT-Solutions.png": 4137,
	"./HomeImg/Client Logo/Tennis-Match.png": 3125,
	"./HomeImg/Client Logo/Venture-Pole.png": 2265,
	"./HomeImg/Client Logo/principalium.png": 6622,
	"./HomeImg/Features-icon-svg/Quality-assurance.png": 8493,
	"./HomeImg/Features-icon-svg/agile.png": 9723,
	"./HomeImg/Features-icon-svg/client-satisfaction.png": 325,
	"./HomeImg/Features-icon-svg/cost-effective-solutions.png": 1668,
	"./HomeImg/Features-icon-svg/dedicated-w.png": 366,
	"./HomeImg/Features-icon-svg/dedicated-w.svg": 8579,
	"./HomeImg/Features-icon-svg/first-w.png": 4435,
	"./HomeImg/Features-icon-svg/first-w.svg": 1249,
	"./HomeImg/Features-icon-svg/one-stop-solution.png": 6406,
	"./HomeImg/Features-icon-svg/team-w.png": 9081,
	"./HomeImg/Features-icon-svg/team-w.svg": 2626,
	"./HomeImg/Florian Hahn-Woernle-tesimonial.jpg": 3737,
	"./HomeImg/Florian Hahn-Woernle-tesimonial.webp": 9905,
	"./HomeImg/General-section-1-img.png": 2780,
	"./HomeImg/General-section-1.webp": 9533,
	"./HomeImg/General-section-2-img.png": 6025,
	"./HomeImg/General-section-2.webp": 7103,
	"./HomeImg/Hero-section-bg.jpg": 4597,
	"./HomeImg/Homepage-Optimized/Homepage-Optimized/Alessandro-testimonial.a077e8f9.webp": 442,
	"./HomeImg/Homepage-Optimized/Homepage-Optimized/Florian Hahn-Woernle-tesimonial.e2deaab0.webp": 8699,
	"./HomeImg/Homepage-Optimized/Homepage-Optimized/General-section-1-img.6a94abc4.webp": 8040,
	"./HomeImg/Homepage-Optimized/Homepage-Optimized/General-section-2-img.064a8f51.webp": 6468,
	"./HomeImg/Homepage-Optimized/Homepage-Optimized/Jugraj-singh-testimonial.417421b9.webp": 6009,
	"./HomeImg/Homepage-Optimized/Homepage-Optimized/Maximilian-testimonial.92a7f85a.webp": 5861,
	"./HomeImg/Homepage-Optimized/Homepage-Optimized/Slide-01.0b7295eb.webp": 9600,
	"./HomeImg/Homepage-Optimized/Homepage-Optimized/Slide-02.c0765813.webp": 8238,
	"./HomeImg/Homepage-Optimized/Homepage-Optimized/contact-us-left-bg -1.d9acc602.webp": 4797,
	"./HomeImg/Homepage-Optimized/Homepage-Optimized/slide-04.50859675.webp": 5569,
	"./HomeImg/Homepage-Optimized/Homepage-Optimized/sumit-bhutani.332130a9.webp": 3644,
	"./HomeImg/Homepage-Optimized/Homepage-Optimized/testimonial1-Stefan.28f93273.webp": 8048,
	"./HomeImg/Homepage-Optimized/Homepage-Optimized/why-choose-us(1).4d57beb1.webp": 5983,
	"./HomeImg/Jugraj-singh-testimonial.jpg": 2617,
	"./HomeImg/Jugraj-singh-testimonial.webp": 7092,
	"./HomeImg/Lee Greene-testimonial.png": 1346,
	"./HomeImg/Maximilian-testimonial.jpg": 1359,
	"./HomeImg/Maximilian-testimonial.webp": 5173,
	"./HomeImg/Service-header.webp": 6065,
	"./HomeImg/Slide-01.0b7295eb.webp": 5979,
	"./HomeImg/Slide-01.png": 5487,
	"./HomeImg/Slide-02.c0765813.webp": 9259,
	"./HomeImg/Slide-02.png": 8243,
	"./HomeImg/Team-Algoson-V2.png": 5334,
	"./HomeImg/Team-Algoson-V2.webp": 9771,
	"./HomeImg/Team-Algoson-version-1.png": 7925,
	"./HomeImg/Team-Algoson-version-1.webp": 1831,
	"./HomeImg/Technologies-intro-png.43f1ab8f (1).webp": 3102,
	"./HomeImg/Technologies-intro-png.png": 1510,
	"./HomeImg/Technology icons/Cassandra_logo.png": 6294,
	"./HomeImg/Technology icons/DynamoDB.png": 3142,
	"./HomeImg/Technology icons/analytics.png": 1444,
	"./HomeImg/Technology icons/angular.png": 9766,
	"./HomeImg/Technology icons/aws.png": 619,
	"./HomeImg/Technology icons/azure.png": 6418,
	"./HomeImg/Technology icons/cloud-connection.png": 5967,
	"./HomeImg/Technology icons/devops.png": 9494,
	"./HomeImg/Technology icons/django.png": 1900,
	"./HomeImg/Technology icons/docker.png": 1116,
	"./HomeImg/Technology icons/flutter.png": 3417,
	"./HomeImg/Technology icons/google-cloud.png": 1097,
	"./HomeImg/Technology icons/icons8-python-96.png": 7790,
	"./HomeImg/Technology icons/java.png": 4830,
	"./HomeImg/Technology icons/javascript.png": 4324,
	"./HomeImg/Technology icons/jupyter.png": 4831,
	"./HomeImg/Technology icons/juypyter.png": 9957,
	"./HomeImg/Technology icons/kotlin.png": 5923,
	"./HomeImg/Technology icons/mariadb.png": 3986,
	"./HomeImg/Technology icons/microservice.png": 1385,
	"./HomeImg/Technology icons/mobile-app.png": 4020,
	"./HomeImg/Technology icons/mongodb.png": 3436,
	"./HomeImg/Technology icons/mysql.png": 8962,
	"./HomeImg/Technology icons/noun-microservices.png": 6770,
	"./HomeImg/Technology icons/oracle.png": 7075,
	"./HomeImg/Technology icons/performance.png": 4603,
	"./HomeImg/Technology icons/plotly.png": 636,
	"./HomeImg/Technology icons/postgresql.png": 4186,
	"./HomeImg/Technology icons/power-bi.png": 5322,
	"./HomeImg/Technology icons/python-flask.png": 1389,
	"./HomeImg/Technology icons/react-native.png": 5113,
	"./HomeImg/Technology icons/react.png": 6393,
	"./HomeImg/Technology icons/redis.png": 3499,
	"./HomeImg/Technology icons/ruby-on-rails-icon.png": 6024,
	"./HomeImg/Technology icons/spring.png": 6593,
	"./HomeImg/Technology icons/springBoot.png": 7902,
	"./HomeImg/Technology icons/sql-database.png": 9266,
	"./HomeImg/Technology icons/sqllite.png": 8966,
	"./HomeImg/Technology icons/swift.png": 9827,
	"./HomeImg/Technology icons/tableau.png": 7988,
	"./HomeImg/Technology icons/ux-design.png": 4912,
	"./HomeImg/Technology icons/vue-js.png": 287,
	"./HomeImg/Technology icons/vuejs.png": 8014,
	"./HomeImg/Testimonial-John.jpg": 9130,
	"./HomeImg/Testimonial-image-John-weeks.jpg": 7945,
	"./HomeImg/Testimonial-image-Sumit.jpg": 2736,
	"./HomeImg/Testimonial1.jpg": 9125,
	"./HomeImg/Testimonial2.png": 4052,
	"./HomeImg/Testimonial3.jpg": 595,
	"./HomeImg/Testimonial4.jpg": 6250,
	"./HomeImg/Testimonials-Section-Background.jpg": 9475,
	"./HomeImg/about.jpg": 9051,
	"./HomeImg/about2.jpg": 1733,
	"./HomeImg/address-icon.png": 4728,
	"./HomeImg/cloud-connection.png": 5987,
	"./HomeImg/contact-us-header.webp": 5309,
	"./HomeImg/contact-us-left-bg -1.d9acc602.webp": 4848,
	"./HomeImg/contact-us-left-bg -1.png": 7271,
	"./HomeImg/contact-us-left-bg-1.webp": 3385,
	"./HomeImg/contact-us-left-bg-1new.png": 673,
	"./HomeImg/cta-section-bg.jpg": 3949,
	"./HomeImg/dedicated-w1.svg": 542,
	"./HomeImg/download-svgrepo-com.svg": 6771,
	"./HomeImg/icons8-location-50.png": 3414,
	"./HomeImg/image-2.png": 6749,
	"./HomeImg/instagram-icon.png": 1108,
	"./HomeImg/launch-salu.png": 7563,
	"./HomeImg/linkedin-icon.png": 2022,
	"./HomeImg/msg-color-png.png": 2254,
	"./HomeImg/multi-screen-testing.png": 9574,
	"./HomeImg/pattern-5-updated.webp": 8895,
	"./HomeImg/pexel-perfect.png": 5226,
	"./HomeImg/phone-color-png.png": 8499,
	"./HomeImg/quote-icon.png": 7828,
	"./HomeImg/slide-04.50859675.webp": 6073,
	"./HomeImg/slide-04.png": 9222,
	"./HomeImg/sumit-bhutani.jpg": 3753,
	"./HomeImg/sumit-bhutani.webp": 13,
	"./HomeImg/testimonial1-Stefan.jpg": 3490,
	"./HomeImg/testimonial1.webp": 5050,
	"./HomeImg/up-arrow.svg": 3555,
	"./HomeImg/why-choose-us(1).png": 5048,
	"./HomeImg/why-choose-us.webp": 5461,
	"./NotFound.png": 3079,
	"./Products/Salu/Group.webp": 3804,
	"./Products/Salu/Landing.mp4": 6498,
	"./Products/Salu/Salu.jpg": 2474,
	"./Products/Salu/Vedio.jpg": 3671,
	"./Products/Salu/Vedio.png": 8692,
	"./Products/Salu/faq.webp": 2525,
	"./Products/Salu/frame.jpg": 6404,
	"./Products/Salu/section.svg": 6859,
	"./Products/Salu/section3.svg": 7624,
	"./Products/Salu/section_01.webp": 5277,
	"./Products/Salu/services-01.jpg": 7152,
	"./Products/Salu/slider.png": 1893,
	"./Products/Salu/white_bg.png": 1203,
	"./ServicesImg/Agile-22.webp": 7543,
	"./ServicesImg/BlueCoat.webp": 5423,
	"./ServicesImg/HeroImage.jpg": 4068,
	"./ServicesImg/Image.png": 1175,
	"./ServicesImg/PNG/Design-light.png": 887,
	"./ServicesImg/PNG/Icon.png": 4285,
	"./ServicesImg/PNG/Shape.png": 1868,
	"./ServicesImg/PNG/arrow.png": 4274,
	"./ServicesImg/PNG/arrow2.png": 973,
	"./ServicesImg/PNG/bg-service.jpg": 1776,
	"./ServicesImg/PNG/bg-service.png": 5647,
	"./ServicesImg/PNG/cloud-computing-light.png": 1724,
	"./ServicesImg/PNG/dev-ops-light.png": 2001,
	"./ServicesImg/PNG/looper-bg.webp": 9319,
	"./ServicesImg/PNG/machine-learning-light.png": 1395,
	"./ServicesImg/PNG/quality-assurance.png": 5570,
	"./ServicesImg/PNG/web-development-light.png": 7717,
	"./ServicesImg/Service-Card-Images/Application/android-development.png": 4290,
	"./ServicesImg/Service-Card-Images/Application/hybrid-app.png": 3765,
	"./ServicesImg/Service-Card-Images/Application/ios-app-development.png": 5616,
	"./ServicesImg/Service-Card-Images/Cloud-Computing/Cloud Integration.png": 2146,
	"./ServicesImg/Service-Card-Images/Cloud-Computing/Cloud Migration.png": 3013,
	"./ServicesImg/Service-Card-Images/Cloud-Computing/Cloud Strategy Consulting.png": 9862,
	"./ServicesImg/Service-Card-Images/Cloud-Computing/Cloud Technology Selection.png": 7602,
	"./ServicesImg/Service-Card-Images/Cloud-Computing/Cloud-first Development.png": 8985,
	"./ServicesImg/Service-Card-Images/Cloud-Computing/Infrastructure Assessments.png": 9561,
	"./ServicesImg/Service-Card-Images/Design/Logo&Branding.png": 630,
	"./ServicesImg/Service-Card-Images/Design/Product-Design.png": 6257,
	"./ServicesImg/Service-Card-Images/Design/UI-UX-design.png": 362,
	"./ServicesImg/Service-Card-Images/Design/Website-Design.png": 5445,
	"./ServicesImg/Service-Card-Images/Design/agile-22de6b038a-6572b8ecb2251.webp": 7682,
	"./ServicesImg/Service-Card-Images/Design/ai.webp": 1940,
	"./ServicesImg/Service-Card-Images/Design/application-performance.png": 7741,
	"./ServicesImg/Service-Card-Images/Design/cc.webp": 3824,
	"./ServicesImg/Service-Card-Images/Design/design-card-6572bac1b819d.jpg": 8095,
	"./ServicesImg/Service-Card-Images/Design/development-card-6572bac26cbb4.webp": 1605,
	"./ServicesImg/Service-Card-Images/Design/devops.webp": 4917,
	"./ServicesImg/Service-Card-Images/Design/qe.webp": 3875,
	"./ServicesImg/Service-Card-Images/Design/service-headerc05e7028-6572b8ebebef5.webp": 5421,
	"./ServicesImg/Service-Card-Images/Design/services-01b5cf6ed1-6572b8eed6f34.webp": 5877,
	"./ServicesImg/Service-Card-Images/DevOps/Application Performance.png": 9586,
	"./ServicesImg/Service-Card-Images/DevOps/CI-Deployment Automation.png": 7294,
	"./ServicesImg/Service-Card-Images/DevOps/Codeless Test Automation.png": 111,
	"./ServicesImg/Service-Card-Images/DevOps/Deployment & Server Monitoring.png": 1314,
	"./ServicesImg/Service-Card-Images/DevOps/Test Automation.png": 8736,
	"./ServicesImg/Service-Card-Images/DevOps/configuration and Management.png": 9709,
	"./ServicesImg/Service-Card-Images/Development/E-commerce.png": 48,
	"./ServicesImg/Service-Card-Images/Development/android-development.png": 9095,
	"./ServicesImg/Service-Card-Images/Development/app-development.png": 9058,
	"./ServicesImg/Service-Card-Images/Development/hybrid-app.png": 1126,
	"./ServicesImg/Service-Card-Images/Development/ios-app-development.png": 1499,
	"./ServicesImg/Service-Card-Images/Development/web-development.jpg": 9284,
	"./ServicesImg/Service-Card-Images/Machine-Learning/Business Intelligence.jpg": 3152,
	"./ServicesImg/Service-Card-Images/Machine-Learning/COMPUTER-VISION.png": 7349,
	"./ServicesImg/Service-Card-Images/Machine-Learning/Data-Engineering.jpg": 3854,
	"./ServicesImg/Service-Card-Images/Machine-Learning/Data-mining.png": 611,
	"./ServicesImg/Service-Card-Images/Machine-Learning/Natural Language Processing.png": 574,
	"./ServicesImg/Service-Card-Images/Machine-Learning/Reinforcement Learning.jpg": 3984,
	"./ServicesImg/Service-Card-Images/Machine-Learning/Supervised-learning.png": 4507,
	"./ServicesImg/Service-Card-Images/Machine-Learning/Time Series Forcasting.jpg": 3124,
	"./ServicesImg/Service-Card-Images/Machine-Learning/data-analysis.png": 761,
	"./ServicesImg/Service-Card-Images/Machine-Learning/unspuervised-learning.png": 7879,
	"./ServicesImg/Service-Card-Images/QA/API-Automation.jpg": 7108,
	"./ServicesImg/Service-Card-Images/QA/Application-Security.jpg": 1019,
	"./ServicesImg/Service-Card-Images/QA/Mannual-QA.png": 4756,
	"./ServicesImg/Service-Card-Images/QA/Manual-QA.jpg": 2136,
	"./ServicesImg/Service-Card-Images/QA/Performance Testing.jpg": 280,
	"./ServicesImg/Service-Card-Images/QA/QA-automation.png": 9619,
	"./ServicesImg/Service-Card-Images/QA/UI-Automation.jpg": 2562,
	"./ServicesImg/ServiceImages/AI/Artificial Intelligence Webp-images/Business Intelligence.webp": 2860,
	"./ServicesImg/ServiceImages/AI/Artificial Intelligence Webp-images/Computer Vision.webp": 9080,
	"./ServicesImg/ServiceImages/AI/Artificial Intelligence Webp-images/Data Engineering.webp": 9931,
	"./ServicesImg/ServiceImages/AI/Artificial Intelligence Webp-images/Natural Language Processing.webp": 9831,
	"./ServicesImg/ServiceImages/AI/Artificial Intelligence Webp-images/Reinforcement Learning.webp": 1629,
	"./ServicesImg/ServiceImages/AI/Artificial Intelligence Webp-images/Service-Header-img.webp": 8771,
	"./ServicesImg/ServiceImages/AI/Artificial Intelligence Webp-images/Supervised Machine Learning.webp": 3062,
	"./ServicesImg/ServiceImages/AI/Artificial Intelligence Webp-images/Time Series Forecasting.webp": 1387,
	"./ServicesImg/ServiceImages/AI/Artificial Intelligence Webp-images/Unsupervised Machine Learning.webp": 7352,
	"./ServicesImg/ServiceImages/AI/Service-Header-img.webp": 18,
	"./ServicesImg/ServiceImages/AI/business-intelligence.webp": 8951,
	"./ServicesImg/ServiceImages/AI/computer-vision.webp": 2396,
	"./ServicesImg/ServiceImages/AI/data-engineering.webp": 2007,
	"./ServicesImg/ServiceImages/AI/natural-language-processing.webp": 2047,
	"./ServicesImg/ServiceImages/AI/reinforcement-learning.webp": 7994,
	"./ServicesImg/ServiceImages/AI/supervised-machine-learning.webp": 46,
	"./ServicesImg/ServiceImages/AI/time-series-forecasting.webp": 2865,
	"./ServicesImg/ServiceImages/AI/unsupervised-machine-learning.webp": 4268,
	"./ServicesImg/ServiceImages/CC/Cloud Computing Webp-Images/Cloud Strategy Consulting.webp": 6778,
	"./ServicesImg/ServiceImages/CC/Cloud Computing Webp-Images/Cloud Technology Selection.webp": 7415,
	"./ServicesImg/ServiceImages/CC/Cloud Computing Webp-Images/Cloud-Migration.webp": 100,
	"./ServicesImg/ServiceImages/CC/Cloud Computing Webp-Images/Cloud-first Development.webp": 8021,
	"./ServicesImg/ServiceImages/CC/Cloud Computing Webp-Images/Cloud-integration.webp": 4965,
	"./ServicesImg/ServiceImages/CC/Cloud Computing Webp-Images/Infrastructure Assessments.webp": 5099,
	"./ServicesImg/ServiceImages/CC/Cloud Computing Webp-Images/Service-Header-img.webp": 6078,
	"./ServicesImg/ServiceImages/CC/Cloud-Migration.webp": 7782,
	"./ServicesImg/ServiceImages/CC/Cloud-integration.webp": 7737,
	"./ServicesImg/ServiceImages/CC/Service-Header-img.webp": 670,
	"./ServicesImg/ServiceImages/CC/cloud-first-development.webp": 4009,
	"./ServicesImg/ServiceImages/CC/cloud-strategy-consulting.webp": 6985,
	"./ServicesImg/ServiceImages/CC/cloud-technology-selection.webp": 8725,
	"./ServicesImg/ServiceImages/CC/infrastructure-assessments.webp": 7778,
	"./ServicesImg/ServiceImages/Design-page-Webp-images/Webp/Logo-and-Branding.webp": 1679,
	"./ServicesImg/ServiceImages/Design-page-Webp-images/Webp/Product-Design.webp": 3477,
	"./ServicesImg/ServiceImages/Design-page-Webp-images/Webp/Service-Header-img.webp": 3196,
	"./ServicesImg/ServiceImages/Design-page-Webp-images/Webp/UI-and-UX-Designing.webp": 2283,
	"./ServicesImg/ServiceImages/Design-page-Webp-images/Webp/Website-Design.webp": 2170,
	"./ServicesImg/ServiceImages/Design/Logo-and-Branding.webp": 3005,
	"./ServicesImg/ServiceImages/Design/Product-Design.webp": 1501,
	"./ServicesImg/ServiceImages/Design/Service-Header-img.webp": 5046,
	"./ServicesImg/ServiceImages/Design/UI-and-UX-Designing.webp": 2205,
	"./ServicesImg/ServiceImages/Design/Website-Design.webp": 7788,
	"./ServicesImg/ServiceImages/DevOps/Service-Header-img.webp": 578,
	"./ServicesImg/ServiceImages/DevOps/ci-cd-pipeline.webp": 6011,
	"./ServicesImg/ServiceImages/DevOps/deployment-&-server-monitoring.webp": 3952,
	"./ServicesImg/ServiceImages/DevOps/security-integration.webp": 5444,
	"./ServicesImg/ServiceImages/Development/HeroImage.0253957f.webp": 9602,
	"./ServicesImg/ServiceImages/Development/Service-Header-img.webp": 1575,
	"./ServicesImg/ServiceImages/Development/WebDev.webp": 8520,
	"./ServicesImg/ServiceImages/Development/android.webp": 4653,
	"./ServicesImg/ServiceImages/Development/digital-transformation.webp": 3872,
	"./ServicesImg/ServiceImages/Development/e-commerce.webp": 3738,
	"./ServicesImg/ServiceImages/Development/hybrid.webp": 2593,
	"./ServicesImg/ServiceImages/Development/ios.webp": 6938,
	"./ServicesImg/ServiceImages/Development/product.webp": 2320,
	"./ServicesImg/ServiceImages/QE/Webp/Service-Header-img.webp": 4190,
	"./ServicesImg/ServiceImages/QE/Webp/api-automation.webp": 8102,
	"./ServicesImg/ServiceImages/QE/Webp/application-security-testing.webp": 5876,
	"./ServicesImg/ServiceImages/QE/Webp/manual-qa.webp": 9699,
	"./ServicesImg/ServiceImages/QE/Webp/performance-testing.webp": 5765,
	"./ServicesImg/ServiceImages/QE/Webp/ui-automation.webp": 7558,
	"./ServicesImg/about-bg-shape.png": 9485,
	"./ServicesImg/agile-perk.webp": 2417,
	"./ServicesImg/background.jpg": 3657,
	"./ServicesImg/icons8-design-64.png": 5751,
	"./ServicesImg/icons8-mobile-app-64.png": 4841,
	"./ServicesImg/icons8-themes-96.png": 8359,
	"./ServicesImg/icons8-ui-design-64.png": 1795,
	"./ServicesImg/icons8-web-64.png": 379,
	"./ServicesImg/icons8-workflow-100-light.png": 4571,
	"./ServicesImg/methdology-bg.png": 4258,
	"./ServicesImg/methdology-bg.webp": 4633,
	"./ServicesImg/more-services.jpg": 1138,
	"./ServicesImg/pexels-fauxels-3183127(1).jpg": 5974,
	"./ServicesImg/pexels-fauxels-3183127.jpg": 6945,
	"./ServicesImg/rectangle.webp": 2751,
	"./ServicesImg/services-team.webp": 7702,
	"./ServicesImg/workflow-bg.png": 104,
	"./Technology/NoSQL-server-light.png": 8512,
	"./Technology/NoSQL-server.png": 8340,
	"./Technology/Technologies-intro-png.webp": 4288,
	"./Technology/backend.png": 7165,
	"./Technology/cloudComputing.png": 2597,
	"./Technology/database.png": 684,
	"./Technology/front-end.png": 5641,
	"./Technology/mobile.png": 7495,
	"./Technology/python.png": 3791,
	"./Technology/reactjs.png": 3549,
	"./Technology/sql-server-light.png": 5623,
	"./Technology/sql-server.png": 3551,
	"./Technology/tools-black.png": 4798,
	"./Technology/tools.png": 1772,
	"./Technology/vuejs.png": 2287,
	"./arrow.svg": 5719
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;